module.exports = __webpack_public_path__ + "img/icon_glossary.bb3ee03a.svg";